import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { Home, Sofa, BookOpen, ArrowRight, PhoneCall } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Test gratuiti (config statica)
const TEST_TABS = [
  {
    title: "Cos'è l'home staging?",
    subtitle: "Fai il test",
    to: "/",
    icon: Home,
  },
  {
    title: "Sai che arredamento ti piace?",
    subtitle: "Scopri il tuo stile",
    to: "/arredamento",
    icon: Sofa,
  },
];

const Prodotti = () => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    axios
      .get(`${API}/commerce/products`)
      .then((r) => setProducts(r.data))
      .catch(() => setProducts([]));
  }, []);

  return (
    <div className="App prodotti-page">
      <Header />

      <section className="prodotti-hero">
        <p className="section-eyebrow">I nostri strumenti</p>
        <h1 className="prodotti-title serif">
          Scopri di più su di te e sulla tua struttura
        </h1>
        <p className="prodotti-sub">
          Test e strumenti pensati per aiutarti a valorizzare la tua struttura
          turistica e aumentare le prenotazioni.
        </p>

        <div className="tab-grid">
          <Link to="/consulenze" className="product-tab tab-wide" data-testid="prodotti-consulenze-btn">
            <div className="tab-icon">
              <PhoneCall size={26} strokeWidth={1.5} />
            </div>
            <div className="tab-text">
              <span className="tab-subtitle">Call 1:1 con Francesca</span>
              <span className="tab-title">Consulenze gratuite e personalizzate</span>
            </div>
            <ArrowRight className="tab-arrow" size={20} strokeWidth={1.8} />
          </Link>
          {/* Test gratuiti */}
          {TEST_TABS.map((tab) => {
            const Icon = tab.icon;
            return (
              <Link key={tab.title} to={tab.to} className="product-tab">
                <div className="tab-icon">
                  <Icon size={26} strokeWidth={1.5} />
                </div>
                <div className="tab-text">
                  <span className="tab-subtitle">{tab.subtitle}</span>
                  <span className="tab-title">{tab.title}</span>
                </div>
                <ArrowRight className="tab-arrow" size={20} strokeWidth={1.8} />
              </Link>
            );
          })}

          {/* Prodotti a pagamento */}
          {products.map((p) => (
            <Link key={p.id} to={`/commerce/${p.id}`} className="product-tab paid">
              <div className="tab-icon">
                <BookOpen size={26} strokeWidth={1.5} />
              </div>
              <div className="tab-text">
                <span className="tab-subtitle">{p.subtitle}</span>
                <span className="tab-title">{p.title}</span>
              </div>
              <ArrowRight className="tab-arrow" size={20} strokeWidth={1.8} />
              <span className="tab-badge">A pagamento</span>
            </Link>
          ))}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Prodotti;
